<template>
    <div class="card-body">
        <div class="dt-ext table-responsive">
            <table class="display" id="show-hidden-row">
                <thead>
                <tr>
                    <th>Week</th>
                    <th>Day</th>
                    <th>Work Times</th>
                    <th>Projects</th>
                    <th>Total time</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(entity, index) in data" :key="index">
                    <td>{{ entity.week }}</td>
                    <td>{{ entity.day }}</td>
                    <td>
                        <ul class="list-none">
                            <li v-for="(work, workIndex) in entity.works" :key="workIndex">
                                {{ work.time_start }} - {{ work.time_end }}
                            </li>
                        </ul>
                    </td>
                    <td>
                        <ul class="list-none">
                            <li v-for="(work, workIndex) in entity.works" :key="workIndex">
                                {{ work.project_title }}
                            </li>
                        </ul>
                    </td>
                    <td>{{ entity.time_total }}</td>
                    <td>
                        <ul class="action list-none">
                            <li class="edit"><a href="#"><i class="icon-pencil-alt"></i></a></li>
                            <li class="delete"><a href="#"><i class="icon-trash"></i></a></li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <basic-modal title="Add Work Time" target-id="work-time-add" set-class="modal-lg">
        <template v-slot:modal_body>
            <work-time-create
                ref="workTimeCreate"
                :allowed-edit-weeks="allowedEditWeeks"
                @weekSelected="handleWeekSelection"
                @workTimeAdded="handleWorkTimeAdded"
                @updateAddTimeState="updateAddTimeState"
            />
        </template>
        <template v-slot:first_button>
            <button :disabled="addTimeDisabled" @click="saveTimeWork()" class="btn btn-outline-info">Add time</button>
        </template>
        <template v-slot:additional_footer_block>
            <summary-block
                :summaryData="summaryData"
                :isEditableWeek="isEditableWeek"
                @work-removed="onWorkRemoved"
            />
        </template>
    </basic-modal>
</template>

<script>
import axios from 'axios';
import BasicModal from "../Basic/BasicModal.vue";
import CreateUser from "../Users/CreateUser.vue";
import WorkTimeCreate from "./WorkTimeCreate.vue";
import ConfirmModal from "../Basic/ConfirmModal.vue";
import SummaryBlock from "./SummaryBlock.vue";

export default {
    name: 'WorkCalendarTable',
    components: { SummaryBlock, ConfirmModal, WorkTimeCreate, CreateUser, BasicModal },
    data() {
        return {
            data: [],
            summaryData: [],
            isCurrentWeek: true,
            addTimeDisabled: true,
            allowedEditWeeks: 2,
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        isEditableWeek(week) {
            const currentWeek = this.$refs.workTimeCreate.getCurrentWeekNumber();
            const allowedWeeks = this.allowedEditWeeks;

            return currentWeek - week < allowedWeeks && currentWeek - week >= 0;
        },

        updateAddTimeState(isDisabled) {
            this.addTimeDisabled = isDisabled;
        },

        fetchData() {
            axios.get('/api/entries')
                .then(response => {
                    if (Array.isArray(response.data)) {
                        this.data = response.data;
                    } else {
                        console.error('Data is not an array:', response.data);
                        this.data = [];
                    }

                    this.$nextTick(() => {
                        const tableId = '#show-hidden-row';
                        if ($.fn.dataTable.isDataTable(tableId)) {
                            const dataTable = $(tableId).DataTable();
                            dataTable.clear().rows.add(this.data).draw();
                        } else {
                            this.initializeDataTable();
                        }
                        this.addDataTitles();
                    });
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        fetchWeeklySummary(selectedWeek) {
            axios
                .get('/api/entries/weekly-times', { params: { week: selectedWeek } })
                .then(response => {
                    if (Array.isArray(response.data)) {
                        this.summaryData = response.data.map(daySummary => ({
                            day: daySummary.day,
                            total_time: daySummary.total_time,
                            week: daySummary.week,
                            works: daySummary.works.map(work => ({
                                id: work.id,
                                project_title: work.project_title,
                                start: work.start,
                                end: work.end,
                            })),
                        }));
                    } else {
                        console.error('Summary data is invalid:', response.data);
                        this.summaryData = [];
                    }
                })
                .catch(error => {
                    console.error('Error fetching summary data:', error);
                });
        },
        handleWeekSelection(selectedWeek) {
            const currentWeek = this.$refs.workTimeCreate.getCurrentWeekNumber();
            this.$refs.workTimeCreate.getCurrentWeekNumber()

            this.isCurrentWeek = Number(selectedWeek) === currentWeek;

            this.fetchWeeklySummary(selectedWeek);
        },
        addDataTitles() {
            const headers = [];
            $('#show-hidden-row thead th').each(function() {
                headers.push($(this).text());
            });

            $('#show-hidden-row tbody tr').each(function() {
                $(this).children('td').each(function(index) {
                    $(this).attr('data-title', headers[index]);
                });
            });
        },
        initializeDataTable() {
            const tableId = '#show-hidden-row';
            $(tableId).DataTable({
                data: this.data,
                columns: [
                    { data: 'week' },
                    { data: 'day' },
                    {
                        data: 'works',
                        render: function(data) {
                            return data.map(work => `${work.time_start} - ${work.time_end}`).join('<br>');
                        }
                    },
                    {
                        data: 'works',
                        render: function(data) {
                            return data.map(work => work.project_title).join('<br>');
                        }
                    },
                    { data: 'time_total' },
                    {
                        data: null,
                        render: function(data, type, row) {
                            return `
                    <ul class="action list-none">
                        <li class="edit"><a href="#"><i class="icon-pencil-alt"></i></a></li>
                        <li class="delete"><a href="#"><i class="icon-trash"></i></a></li>
                    </ul>
                `;
                        }
                    }
                ],
                ordering: false,
                responsive: {
                    details: {
                        display: $.fn.dataTable.Responsive.display.childRowImmediate,
                        type: ''
                    }
                },
                dom: 'lBtip',
                buttons: [
                    {
                        text: 'Add work Time',
                        action: (e, dt, node, config) => {
                            this.openModal();
                        }
                    }
                ]
            });
        },
        openModal() {
            this.$refs.workTimeCreate.fetchProjects();
            this.$refs.workTimeCreate.clearSelections();

            $('#work-time-add').modal('show');
        },
        saveTimeWork() {
            this.$refs.workTimeCreate.saveWorkTime();
        },
        handleWorkTimeAdded() {
            this.fetchData();
            this.fetchWeeklySummary(this.$refs.workTimeCreate.selectedWeek);
        },
        updateSummary(data) {
            this.summaryData = data.map(entry => ({
                project_title: entry.project_title,
                start: entry.start,
                end: entry.end,
            }));
        },

        onWorkRemoved() {
            this.fetchData();
            this.fetchWeeklySummary(this.$refs.workTimeCreate.selectedWeek);
        },
    },
};
</script>

<style scoped>
.list-none {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.action {
    display: flex;
}

.action li {
    margin-right: 10px;
}

.table-responsive {
    overflow-x: inherit;
}

.btn-outline-info:disabled {
    color: #888;
    border-color: #888;
}
</style>
